<style scoped lang="scss"></style>
<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/out/order/detail/page" getKey="rows" :columns="columns" @afterGet="afterGet">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="putOutAll" type="primary" :loading="putOutAllLoading" :disabled="availableList.length === 0">{{ $t('quanbuchuku') }}</el-button>
      </template>

      <template #mingxizhuangtai="scope">
        <span v-if="scope.row.status === 0">{{ $t('weichuku') }}</span>
        <span v-if="scope.row.status === 1">{{ $t('bufenchuku') }}</span>
        <span v-if="scope.row.status === 2">{{ $t('quanbuchuku') }}</span>
      </template>
      <template #wuliaobianmamingcheng="scope">
        <span v-if="scope.row.material">{{ scope.row.material.code }} / {{ scope.row.material.name }}</span>
      </template>
      <template #bencishichu="scope">
        <div style="display: flex;justify-content: center;align-items: center;">
          <div v-if="scope.row.dueQuantity === 0">0</div>
          <el-input-number v-else size="mini" v-model="scope.row.newTransactionQuantity" :min="0" :max="scope.row.dueQuantity" :precision="5"></el-input-number>
        </div>
      </template>
      <template #cangkukuqukuwei="scope">
        <div style="display: flex;justify-content: center;align-items: center;" v-if="scope.row.dueQuantity > 0">
          <el-select size="mini" v-model="scope.row.inventory" :placeholder="$t('qingxuanze')" v-if="scope.row.inventoryList" value-key="id" clearable filterable>
            <el-option v-for="item in scope.row.inventoryList" :key="item.id" :label="formatWarehouse(item)" :value="item"> </el-option>
          </el-select>
        </div>
      </template>
      <!-- <template #cangkukuqukuwei="scope">
        <div style="display: flex;justify-content: center;align-items: center;" v-if="scope.row.dueQuantity > 0">
          <yi_data_select key="1" v-if="scope.row.queryFilter" :showAllLevels="true" :multiple="false" :max="1" :checkStrictly="true" :warehouseLevel="2" type="warehouse" :idsPathParent.sync="scope.row.idsPathParent" :ids.sync="scope.row.warehouseId" :queryFilter="scope.row.queryFilter"> </yi_data_select>
        </div>
      </template> -->
      <template #caozuochukuzhuangtai="scope">
        <div v-if="runStorageStatusMap.get(scope.row.id)">
          <el-tag :type="runStorageStatusMap.get(scope.row.id) === 'success' ? 'success' : 'danger'">{{ $t(runStorageStatusMap.get(scope.row.id))  }}</el-tag>
        </div>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.dueQuantity > 0">
            <el-button type="text" @click="putOut(scope.row)" :loading="scope.row.putOutLoading">{{ $t('chuku') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
import Bury from '@/common/bury.js';

export default {
  name: 'web_wms_delivery_without_order_storage',
  components: {},
  props: {
    // 生产配置-产品色号管理
    colorNoEnable: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      putOutAllLoading: false,
      runStorageStatusMap: new Map(),
      columns: [
        {
          label: 'mingxizhuangtai',
          prop: 'status',
          type: 'slot',
          width: 100
        },
        {
          label: 'wuliaobianmamingcheng',
          type: 'slot'
        },
        {
          label: 'danwei',
          prop: 'unit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE',
          width: 100
        },
        {
          label: 'wuliaopicihao',
          prop: 'materialBatchNo',
          width: 150
        },
        {
          label: 'chukushuliang',
          prop: 'quantity',
          width: 100
        },
        {
          label: 'shichushuliang',
          prop: 'actualQuantity',
          width: 100
        },
        {
          label: 'weichushuliang',
          prop: 'dueQuantity',
          width: 100
        },
        {
          label: 'bencishichu',
          type: 'slot',
          isStar: true
        },
        {
          label: 'cangkukuqukuwei',
          type: 'slot',
          isStar: true
        },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          show: this.colorNoEnable
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuochukuzhuangtai',
          prop: 'runStorageStatus',
          type: 'slot'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  computed: {
    availableList() {
      if (this.yt.list) {
        let arr = [];
        const list = this.yt.list || [];
        for (let i = 0; i < list.length; i++) {
          if (list[i].dueQuantity === 0) {
            continue;
          }
          arr.push(list[i]);
        }
        return arr;
      } else {
        return [];
      }
    }
  },
  created() {
    setTimeout(() => {
      if (this.row) {
        this.yt.conditions = {
          outOrderId: this.row.id
        };
      }
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 全部出库
    putOutAll() {
      Bury.buryAdd({ functionType: '用户行为', logType: '按钮点击', startData: { s1: '无单出库-全部出库' } });
      this.putOutAllLoading = true;
      let list = this.yt.list || [];
      let completedCount = 0;
      const totalItems = list.filter(row => row.dueQuantity !== 0).length;
      for (let i = 0; i < list.length; i++) {
        const row = list[i];
        if (list[i].dueQuantity === 0) {
          continue;
        }

        // putOut 方法内部会调用一个回调函数来通知完成
        this.$set(row, 'putOutCallback', () => {
          completedCount++;
          if (completedCount === totalItems) {
            this.putOutAllLoading = false;
            this.$message.success(this.$t('chukuwancheng'));
            this.yt.get();
          }
        });
        this.putOut(row, false);
      }
    },
    // 单个出库
    putOut(row, refresh = true) {
      if (!row.inventory) {
        if (refresh) {
          this.$message.warning(this.$t('chukubixuxuanzecangku'));
        }
        // this.$set(row, 'runStorageStatus', 'chukubixuxuanzecangku');
        this.runStorageStatusMap.set(row.id, 'chukubixuxuanzecangku');
        if (row.putOutCallback) {
          row.putOutCallback();
        }
        return;
      }

      const data = {
        id: row.id,
        materialId: row.material.id,
        materialBatchNo: row.materialBatchNo,
        quantity: row.quantity,
        dueQuantity: row.dueQuantity,
        actualQuantity: row.actualQuantity,
        newTransactionQuantity: row.newTransactionQuantity,
        saleOrderDetailId: row.saleOrderDetailId,
        materialInventoryList: []
      };
      data.materialInventoryList.push({
        id: row.inventory.id,
        newTransactionQuantity: row.newTransactionQuantity,
        total: row.inventory.total
      });
      if (refresh) {
        Bury.buryAdd({ functionType: '用户行为', logType: '按钮点击', startData: { s1: '无单出库-单个出库' } });
      }
      this.$set(row, 'putOutLoading', true);
      this.http
        .post('/web/out/order/detail/sendOut', data)
        .then(res => {
          this.runStorageStatusMap.set(row.id, res.msg);
          if (refresh) {
            this.$message.success(this.$t(res.msg));
            this.yt.get();
          }
        })
        .catch(err => {
          this.runStorageStatusMap.set(row.id, err);
          if (refresh) {
            this.$message.error(this.$t(err));
          }
        })
        .finally(() => {
          this.$set(row, 'putOutLoading', false);
          if (row.putOutCallback) {
            row.putOutCallback();
          }
        });
    },
    // 格式化仓库-库区-库位
    formatWarehouse(item) {
      if (!item) {
        return '';
      }
      let str = '';
      if (item.warehouse) {
        str += item.warehouse.name;
        if (item.warehouseArea) {
          str += '/' + item.warehouseArea.name;
          if (item.warehouseLocation) {
            str += '/' + item.warehouseLocation.name;
          }
        }
      }
      return str;
    },
    // 表格数据获取成功后
    afterGet() {
      let list = this.yt.list || [];
      // 初始化本次实收值为未收数量、默认仓库库区库位
      for (let i = 0; i < list.length; i++) {
        if (list[i].dueQuantity === 0) {
          continue;
        }
        this.$set(list[i], 'newTransactionQuantity', list[i].dueQuantity || 0);
        this.$set(list[i], 'idsPathParent', []);
        this.setLatestWarehouse(list[i]);
      }
    },
    // 通过出库明细的“物料编码/名称”和“单位”，匹配“物料库存”表字段“可用数”大于0 的数，若匹配数据只有一个，则直接显示，若有多个则通过下拉选择
    setLatestWarehouse(row) {
      this.http.get(`/web/material/inventory/pageAvailbleInventory?pageNum=1&pageSize=999&materialId=${row.material.id}&unit=${row.unit}`).then(res => {
        const rows = res.data && res.data.rows;
        if (!rows) {
          return;
        }
        this.$set(row, 'inventoryList', rows);
        if (rows.length === 1) {
          this.$set(row, 'inventory', rows[0]);
        }

        // let warehouseIds = rows.map(item => parseInt('1' + item.warehouseId));
        // warehouseIds = [...new Set(warehouseIds)];
        // const queryFilter = item => {
        //   return warehouseIds.indexOf(item.id) !== -1;
        // };
        // this.$set(row, 'queryFilter', queryFilter);
        // if (rows.length === 1) {
        //   const data = rows[0];
        //   if (data.warehouseLocationId) {
        //     this.$set(row, 'warehouseId', parseInt('3' + data.warehouseLocationId));
        //     return;
        //   }
        //   if (data.warehouseAreaId) {
        //     this.$set(row, 'warehouseId', parseInt('2' + data.warehouseAreaId));
        //     return;
        //   }
        //   if (data.warehouseId) {
        //     this.$set(row, 'warehouseId', parseInt('1' + data.warehouseId));
        //     return;
        //   }
        // }
      });
    }
  }
};
</script>
